import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useEffect } from "react";
import { useState } from "react";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Swal from "sweetalert2";
import "./leavePolicies.css";

function LeaveTypes() {
  const [permissions, setPermissions] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [editLeaveType, setEditLeaveType] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);

  const [leave, setLeave] = useState({
    id: "",
    leave_name: "",
    leave_code: "",
    is_paid: true,
    requires_approval: true,
    is_partial_allowed: true,
    description: "",
  });

  useEffect(() => {
    const perms = getPermissions();
    if (perms) {
      setPermissions(perms);
    }
  }, []);

  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  const handleAddNew = () => {
    setLeave({
      id: "",
      leave_name: "",
      leave_code: "",
      is_paid: true,
      requires_approval: true,
      is_partial_allowed: true,
      description: "",
    });
    setErrors({});
    setOpenModal(true);
    setEditLeaveType(false);
  };
  const handleInputChange = (field, value) => {
    setLeave((pre) => ({
      ...pre,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };
  //   handle form validation
  const validateForm = () => {
    const newErrors = {};
    if (!leave?.leave_name) newErrors.leave_name = "Leave name is required";
    if (!leave?.leave_code) newErrors.leave_code = "Leave code is required";
    if (!leave?.description)
      newErrors.description = "Leave description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  //   handle save the leave type
  const handleSave = async () => {
    if (!validateForm()) return;
    setLoading(true);

    try {
      let response;

      if (editLeaveType) {
        response = await apiUrl.post(`/update_leave_type/${leave.id}`, {
          leave_name: leave.leave_name,
          leave_code: leave.leave_code,
          description: leave.description,
          is_paid: leave.is_paid,
          requires_approval: leave.requires_approval,
          is_partial_allowed: leave.is_partial_allowed,
        });
      } else {
        response = await apiUrl.post("/add_leave_type", {
          leave_name: leave.leave_name,
          leave_code: leave.leave_code,
          description: leave.description,
          is_paid: leave.is_paid,
          requires_approval: leave.requires_approval,
          is_partial_allowed: leave.is_partial_allowed,
        });
      }

      if (response?.status) {
        Swal.fire({
          title: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        setOpenModal(false);
        setEditLeaveType(false); // reset mode after save
        fetchLeaveTypes();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  //   fetch leave types
  const fetchLeaveTypes = async () => {
    setShowSkeleton(true);
    try {
      const response = await apiUrl.get("/get_leave_types");
      if (response.status) {
        setLeaveTypes(response?.data?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowSkeleton(false);
    }
  };
  //   handle edit leave type
  const handleEditLeaveType = (leave) => {
    setOpenModal(true);
    setEditLeaveType(true);
    setLeave({
      id: leave.id,
      leave_name: leave.name,
      leave_code: leave.code,
      is_paid: leave.is_paid,
      requires_approval: leave.requires_approval,
      is_partial_allowed: leave.is_partial_allowed,
      description: leave.description,
    });
  };
  //   handle delete leave type
  const handleDeleteLeave = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.delete(`/delete_leave_type/${id}`);
          if (response?.status) {
            Swal.fire({
              title: "Deleted!",
              text: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
            });
            fetchLeaveTypes();
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };
  const paidCount = leaveTypes.filter((l) => l.is_paid).length;
  const approvalCount = leaveTypes.filter((l) => l.requires_approval).length;

  return (
    <>
      {permissions["manage_policies"] === 1 && (
        <div>
          {/* Stats row */}
          {!showSkeleton && leaveTypes.length > 0 && (
            <div className="row g-3 mb-4">
              <div className="col-sm-4">
                <div className="lp-stat-card d-flex align-items-center gap-3">
                  <div className="lp-stat-icon bg-primary bg-opacity-10 text-primary">
                    <FaIcons.FaTags />
                  </div>
                  <div>
                    <div className="lp-stat-label">Total Leave Types</div>
                    <div className="lp-stat-value">{leaveTypes.length}</div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="lp-stat-card d-flex align-items-center gap-3">
                  <div className="lp-stat-icon bg-success bg-opacity-10 text-success">
                    <FaIcons.FaMoneyBillWave />
                  </div>
                  <div>
                    <div className="lp-stat-label">Paid Leave Types</div>
                    <div className="lp-stat-value">{paidCount}</div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="lp-stat-card d-flex align-items-center gap-3">
                  <div className="lp-stat-icon bg-warning bg-opacity-10 text-warning">
                    <FaIcons.FaUserCheck />
                  </div>
                  <div>
                    <div className="lp-stat-label">Requires Approval</div>
                    <div className="lp-stat-value">{approvalCount}</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="lp-config-panel">
            <div className="lp-config-panel-header d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span className="lp-stat-icon bg-primary bg-opacity-10 text-primary" style={{ width: 36, height: 36, fontSize: "0.875rem" }}>
                    <FaIcons.FaTags />
                  </span>
                  <h5 className="fw-bold mb-0">Leave Types Configuration</h5>
                </div>
                <p className="text-muted small mb-0 ps-1">
                  Define and manage categories of leave available to employees
                </p>
              </div>
              <button className="btn btn-primary d-flex align-items-center gap-2 px-3" onClick={handleAddNew}>
                <FaIcons.FaPlus size={12} />
                Add Leave Type
              </button>
            </div>

            <div className="lp-config-panel-body">
          {showSkeleton && (
            <div className="lp-lt-grid">
              {Array.from({ length: 6 }).map((_, idx) => (
                <div key={idx} className="lp-leave-type-card">
                  <div className="lp-lt-accent paid" />
                  <div className="lp-lt-card-inner placeholder-glow">
                    <div className="d-flex gap-2 align-items-center">
                      <div className="placeholder rounded" style={{ width: 36, height: 36 }} />
                      <div className="flex-grow-1">
                        <span className="placeholder col-8 mb-1 d-block rounded" />
                        <span className="placeholder col-4 d-block rounded" />
                      </div>
                    </div>
                    <span className="placeholder col-12 d-block rounded" style={{ height: 14 }} />
                    <div className="d-flex gap-1">
                      <span className="placeholder rounded-pill" style={{ width: 48, height: 18 }} />
                      <span className="placeholder rounded-pill" style={{ width: 48, height: 18 }} />
                      <span className="placeholder rounded-pill" style={{ width: 48, height: 18 }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {!showSkeleton && leaveTypes.length === 0 && (
              <div className="lp-empty-state">
                <div className="empty-icon">
                  <FaIcons.FaCalendarTimes size={28} />
                </div>
                <h5 className="fw-semibold">No Leave Types Found</h5>
                <p className="text-muted small mb-3">
                  Create your first leave type to start configuring policies.
                </p>
                <button className="btn btn-primary btn-sm" onClick={handleAddNew}>
                  <FaIcons.FaPlus className="me-1" />
                  Add Leave Type
                </button>
              </div>
          )}

          {!showSkeleton && leaveTypes.length > 0 && (
            <div className="lp-lt-grid">
              {leaveTypes.map((leave) => (
                <div key={leave.id} className="lp-leave-type-card">
                  <div className={`lp-lt-accent ${leave.is_paid ? "paid" : "unpaid"}`} />
                  <div className="lp-lt-card-inner">
                    <div className="lp-lt-top">
                      <div className="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
                        <div className={`lp-lt-icon-wrap ${leave.is_paid ? "paid" : "unpaid"}`}>
                          <FaIcons.FaCalendarAlt />
                        </div>
                        <div className="min-w-0">
                          <div className="lp-lt-title text-truncate">{leave.name}</div>
                          <div className="lp-lt-meta">
                            <span className="lp-lt-code">{leave.code}</span>
                            <span className={`lp-lt-type-pill ${leave.is_paid ? "paid" : "unpaid"}`}>
                              {leave.is_paid ? "Paid" : "Unpaid"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="lp-lt-actions">
                        <button
                          type="button"
                          className="lp-lt-action-btn"
                          title="Edit"
                          onClick={() => handleEditLeaveType(leave)}
                        >
                          <FaIcons.FaEdit size={11} />
                        </button>
                        <button
                          type="button"
                          className="lp-lt-action-btn danger"
                          title="Delete"
                          onClick={() => handleDeleteLeave(leave.id)}
                        >
                          <FaIcons.FaTrashAlt size={11} />
                        </button>
                      </div>
                    </div>

                    <p className="lp-lt-desc">
                      {leave.description || "No description provided."}
                    </p>

                    <div className="lp-lt-tags">
                      <span className={`lp-lt-tag ${leave.is_paid ? "on" : "off"}`}>
                        <FaIcons.FaMoneyBillWave size={9} />
                        Paid
                      </span>
                      <span className={`lp-lt-tag warn ${leave.requires_approval ? "on" : "off"}`}>
                        <FaIcons.FaUserCheck size={9} />
                        Approval
                      </span>
                      <span className={`lp-lt-tag info ${leave.is_partial_allowed ? "on" : "off"}`}>
                        <FaIcons.FaClock size={9} />
                        Partial
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
            </div>
          </div>

          {/* model */}
          {openModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
                onClick={() => setOpenModal(false)}
              />
              <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
                style={{ zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-lg"
                  style={{ maxWidth: 700 }}
                >
                  <div
                    className="modal-content border-0 rounded-4 shadow"
                    style={{ overflow: "hidden" }}
                  >
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <div>
                        <h5 className="modal-title" style={{ fontWeight: 700 }}>
                          {editLeaveType ? "Edit Leave Type" : "Add Leave Type"}
                        </h5>
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                      />
                    </div>
                    {/* modal body */}
                    <div className="modal-body py-3 px-4">
                      <div className="d-flex flex-column gap-3">
                        {/* Name and Code - single row */}
                        <div className="d-flex gap-3">
                          <div style={{ flex: 1 }}>
                            <label className="form-label mb-1">
                              Leave Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.leave_name ? "is-invalid" : ""
                              }`}
                              value={leave.leave_name}
                              placeholder="e.g., Sick Leave"
                              onChange={(e) =>
                                handleInputChange("leave_name", e.target.value)
                              }
                            />
                            {errors.leave_name && (
                              <div className="invalid-feedback d-block">
                                {errors.leave_name}
                              </div>
                            )}
                          </div>
                          <div style={{ flex: 1 }}>
                            <label className="form-label mb-1">
                              Leave Code <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.leave_code ? "is-invalid" : ""
                              }`}
                              value={leave.leave_code}
                              placeholder="e.g., SL"
                              onChange={(e) =>
                                handleInputChange("leave_code", e.target.value)
                              }
                            />
                            {errors.leave_code && (
                              <div className="invalid-feedback d-block">
                                {errors.leave_code}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Description */}
                        <div>
                          <label className="form-label mb-1">
                            Description
                            <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className={`form-control ${
                              errors.description ? "is-invalid" : ""
                            }`}
                            rows="2"
                            value={leave.description}
                            placeholder="Explain when this leave should be used..."
                            onChange={(e) =>
                              handleInputChange("description", e.target.value)
                            }
                          />
                          {errors.description && (
                            <div className="invalid-feedback d-block">
                              {errors.description}
                            </div>
                          )}
                        </div>

                        {/* Compact Toggle Section */}
                        <div className="d-flex flex-column gap-2">
                          {/* Is Paid */}
                          <div className="d-flex align-items-center justify-content-between p-2 bg-light rounded border">
                            <div>
                              <h6 className="mb-0 fw-normal">Is Paid?</h6>
                              <small className="text-muted">
                                Employee receives salary during leave
                              </small>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                style={{ width: "36px", height: "18px" }}
                                checked={leave.is_paid}
                                onChange={(e) =>
                                  handleInputChange("is_paid", e.target.checked)
                                }
                              />
                            </div>
                          </div>

                          {/* Requires Approval */}
                          <div className="d-flex align-items-center justify-content-between p-2 bg-light rounded border">
                            <div>
                              <h6 className="mb-0 fw-normal">
                                Requires Approval?
                              </h6>
                              <small className="text-muted">
                                Manager must approve before leave is granted
                              </small>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                style={{ width: "36px", height: "18px" }}
                                checked={leave.requires_approval}
                                onChange={(e) =>
                                  handleInputChange(
                                    "requires_approval",
                                    e.target.checked
                                  )
                                }
                              />
                            </div>
                          </div>

                          {/* Allow Partial Leave */}
                          <div className="d-flex align-items-center justify-content-between p-2 bg-light rounded border">
                            <div>
                              <h6 className="mb-0 fw-normal ">
                                Allow Partial Leave?
                              </h6>
                              <small className="text-muted">
                                Enables half-day and short (hourly) leave
                                options
                              </small>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                style={{ width: "36px", height: "18px" }}
                                checked={leave.is_partial_allowed}
                                onChange={(e) =>
                                  handleInputChange(
                                    "is_partial_allowed",
                                    e.target.checked
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* model footer */}
                    <div
                      className="modal-footer"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setOpenModal(false)}
                        disabled={loading}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Saving...
                          </>
                        ) : (
                          <>
                            {editLeaveType
                              ? "Edit Leave Type"
                              : "Save Leave Type"}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default LeaveTypes;
